import getCustomerParameters from '../../api/finance/CustomerParameters';
import cleansePositiveNumber from '../../../modules/cleansePositiveNumber';
import { getDefaultTerm, getDefaultMileage, getDefaultDeposit } from '../../api/finance/GetDefaults';
import { saveToStorage } from '../../api/Storage';

const state = {
    term: false,
    deposit: false,
    mileage: false,
    payment: false,
    modified: false,
    initialized: false,
};

const getters = {
    modified(state) {
        return state.modified;
    },
    term(state) {
        if (state.term == false) {
            return (brand, key) => getDefaultTerm(brand, key);
        }
        return (brand, key) => state.term;
    },
    deposit(state) {
        if (state.deposit === false) {
            return (vehicle, key) => getDefaultDeposit(vehicle, key);
        }
        return (vehicle, key) => state.deposit;
    },
    mileage(state) {
        if (state.mileage == false) {
            return (brand, key) => getDefaultMileage(brand, key);
        }
        return (brand, key) => state.mileage;
    },
    parameters(state) {
        return (brand, key) => {
            if (typeof brand == 'undefined') {
                brand = '';
            }
            if (typeof key == 'undefined') {
                key = '';
            }
            let data = {
                term: state.term,
                deposit: state.deposit,
                mileage: state.mileage,
                payment: state.payment,
                modified: state.modified,
            };
            if (state.term == false) {
                data.term = getDefaultTerm(brand, key);
            }
            if (state.deposit == false) {
                data.deposit = getDefaultDeposit(brand, key);
            }
            if (state.mileage == false) {
                data.mileage = getDefaultMileage(brand, key);
            }
            return data;
        };
    },
};

const actions = {
    initialize({ commit, state }) {
        if (state.initialized) {
            return;
        }
        commit('setFinanceData', getCustomerParameters());
    },
};

const mutations = {
    setFinanceTerm(state, value) {
        state.modified = true;
        state.term = cleansePositiveNumber(value, false);
        saveToStorage('used.term', state.term);
    },
    setFinanceDeposit(state, value) {
        state.modified = true;
        state.deposit = cleansePositiveNumber(value, false);
        saveToStorage('used.deposit', state.deposit);
    },
    setFinanceMileage(state, value) {
        state.modified = true;
        state.mileage = cleansePositiveNumber(value, false);
        saveToStorage('used.mileage', state.mileage);
    },
    setFinancePayment(state, value) {
        state.modified = true;
        state.payment = cleansePositiveNumber(value, false);
        saveToStorage('used.payment', state.payment);
    },
    setFinanceData(state, data) {
        state.initialized = true;
        state.term = data.term;
        state.deposit = data.deposit;
        state.mileage = data.mileage;
        state.payment = data.payment;
        if (state.term != false || state.deposit != false || state.mileage != false || state.payment != false) {
            state.modified = true;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};